import type { ContentType } from "@brookbush/database";

import { useAuth } from "@clerk/nextjs";
import { useEffect, useRef } from "react";
import { mutate as globalMutate } from "swr";

import fetcher from "~/utils/fetcher.client";

interface UseTrackHistoryProps {
	contentType: ContentType;
	contentId: string;
}

const useTrackHistory = ({ contentId, contentType }: UseTrackHistoryProps) => {
	const { userId, actor } = useAuth();
	const isTriggered = useRef<string>(null);

	useEffect(() => {
		if (userId && isTriggered.current !== contentId && !actor) {
			isTriggered.current = contentId;

			fetcher("/history", {
				method: "POST",
				data: {
					contentId,
					contentType,
				},
			});

			globalMutate("/onboarding/checklist");
		}
	}, [contentId, contentType, userId, actor]);

	return null;
};

export default useTrackHistory;
